import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    micPermission: false,
    camPermission: false,
  },
  mutations: {
    updateMicPermission(state) {
      state.micPermission = true;
    },
    updateCamPermission(state) {
      state.camPermission = true;
    },
  },
})


// WEBPACK FOOTER //
// ./src/store/index.js